import React, {Component} from 'react';
import Card from 'react-bootstrap/Card';
const $ = require('jquery');
const jzip = require('jzip');
window.JSZip = jzip;

const columns = [
  {
    title: '#',
    data: 'CAR_ID'
  },
  {
    title: 'หมายเลขรถ',
    data: 'PLATE_NO'
  },
  {
    title: 'ชื่อคนขับ',
    data: 'NAME'
  },
  {
    title: 'ประเภทรถ',
    data: 'TYPE'
  },
  {
    title: 'สำนักงาน',
    data: 'SITE'
  },
  {
    title: 'เบอร์โทร',
    data: 'PHONE'
  },
  {
    title: 'แก้ไข',
    data: 'CAR_ID',
    render: function (data, type) {
      if (type === 'display') {
        // return `<a class="btn btn-outline-primary btn-sm">แก้ไข</a>`;
        return `<input class="btn btn-outline-primary btn-sm" type="button" value="แก้ไข" id="e-${data}"> <input class="btn btn-outline-secondary btn-sm" type="button" value="Reset password" id="e-${data}">`;
        // return `<a class="text-muted"><i class="fas fa-pencil" /></a>`;
      }
      return data;
    }
  },
  {
    title: 'รูปรถ',
    data: 'IMG_CAR',
    render: function (data, type) {
      return `<a href="${data.replaceAll('?size=300', '')}" target="_blank"><img
      src="${data}"
      style="cursor: pointer;"
      class="img-rounded img-size-24 mr-2"
    /></a>`;
    }
  },
  {
    title: 'รูปคน',
    data: 'IMG_DRIVER',
    render: function (data, type) {
      return `<a href="${data.replaceAll('?size=300', '')}" target="_blank"><img
      src="${data}"
      style="cursor: pointer;"
      class="img-rounded img-size-24 mr-2"
    /></a>`;
    }
  }
];

function reloadTableData(items, page) {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const table = $(`#${0}`).DataTable();
  table.clear();

  table.rows.add(items);
  table.draw();
  table.page(page).draw('page');
}

function hideCols(show) {
  console.log('hide');
  var column5 = $(`#${0}`).DataTable().column(5);
  var column6 = $(`#${0}`).DataTable().column(6);
  column5.visible(show);
  column6.visible(show);
}

class TableDriverItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opts: [],
      selected: null,
      date_start: null,
      date_stop: null,
      select: true
    };
  }

  componentDidMount() {
    var table = $(`#${0}`).DataTable({
      data: this.props.items,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      scrollX: true,
      errMode: 'none',
      // responsive: true,
      // columnDefs: [{target: 6, visible: false}],
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_driver_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_driver_excel_${Date.now()}`
        }
      ]
    });
    $.fn.dataTable.ext.errMode = 'none';

    // $(`#${0} tbody`).on('click', 'a', (event) => {
    //   var $this = $(event.currentTarget);
    //   var data = table.row($this.parents('tr')).data();
    //   this.props.onToggle(data);
    // });

    $(`#${0} tbody`).on('click', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      if (event.currentTarget.value === 'แก้ไข') {
        this.props.onToggle(data);
      }

      if (event.currentTarget.value === 'Reset password') {
        this.props.onResetToggle(data);
      }
    });

    table.on('page', (event) => {
      var info = table.page.info();
      this.props.onPageChange(info.page);
    });
  }

  componentWillUnmount() {
    $(`#${0}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    // if (nextProps.items.length !== this.props.items.length) {
    if (nextProps.cr !== true) {
      hideCols(false);
      reloadTableData([], 0);
    } else {
      hideCols(true);
      reloadTableData(nextProps.items, nextProps.page);
    }
    // }
    return true;
  }

  render() {
    return (
      <div>
        <Card className="card">
          <div className={this.props.cr === true ? 'd-none' : 'overlay dark'}>
            <span style={{color: 'white', fontSize: 30}}>CR ONLY</span>
          </div>
          <Card.Header>
            <Card.Title>
              รายชื่อคนขับรถบริการ เลือกค้นโดยพิมพ์ "DAP เก๋ง" หรือ "IP1 ตู้"
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={0}
              style={{width: '100%'}}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
export default TableDriverItem;
